// HEAL-86 (stage-1 §8.1) — окно техработ.
//
// Пока на сервере идёт заливка каталога, API отвечает 503 с `error: "maintenance"`.
// Без этого флага человек видел бы на каждом экране «Не удалось загрузить — Повторить»
// и не понимал, сломалось ли что-то у него. Флаг живёт вне React, потому что ставит
// его axios-перехватчик; приложение подписывается через useMaintenance.
//
// Признак — именно `error: "maintenance"`, а не любой 503: тот же код бэкенд отдаёт,
// когда разбор не встал в очередь (`parser_unavailable`), и это не техработы.

import { useSyncExternalStore } from 'react';

let active = false;
const listeners = new Set<() => void>();

function set(next: boolean): void {
  if (active === next) return;
  active = next;
  listeners.forEach((fn) => fn());
}

export const maintenance = {
  enter: (): void => set(true),
  leave: (): void => set(false),
  isActive: (): boolean => active,
  subscribe: (fn: () => void): (() => void) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};

export function isMaintenanceResponse(status: number | undefined, data: unknown): boolean {
  return (
    status === 503 &&
    typeof data === 'object' &&
    data !== null &&
    (data as { error?: unknown }).error === 'maintenance'
  );
}

export function useMaintenance(): boolean {
  return useSyncExternalStore(maintenance.subscribe, maintenance.isActive, maintenance.isActive);
}
